// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.totals {
  display: flex;
  justify-content: space-between;
  color: #f97561;
}

.dataTables_info {
  white-space: nowrap;
  font-size: 0.9rem;
}

:host ::ng-deep .table_footer {
  width: 100%;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}

:host ::ng-deep .table_footer > div {
  padding: 5px;
  min-width: 200px;
}

.pagination {
  margin-bottom: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.page-item {
  margin: 2px;
}

.page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
}

.pl-0 {
  padding-left: 0 !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRhYmxlLWZvb3Rlci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGFBQUE7RUFDQSw4QkFBQTtFQUNBLGNBQUE7QUFDSjs7QUFFQTtFQUNJLG1CQUFBO0VBQ0EsaUJBQUE7QUFDSjs7QUFFQTtFQUNJLFdBQUE7RUFDQSxlQUFBO0VBQ0EsVUFBQTtFQUNBLFNBQUE7RUFDQSxhQUFBO0VBQ0EsOEJBQUE7QUFDSjs7QUFFQTtFQUNJLFlBQUE7RUFDQSxnQkFBQTtBQUNKOztBQUVBO0VBQ0ksZ0JBQUE7RUFDQSxlQUFBO0VBQ0EseUJBQUE7QUFDSjs7QUFFQTtFQUNJLFdBQUE7QUFDSjs7QUFFQTtFQUNJLHVCQUFBO0VBQ0EsbUJBQUE7RUFDQSxlQUFBO0FBQ0o7O0FBRUE7RUFDSSwwQkFBQTtBQUNKIiwiZmlsZSI6InRhYmxlLWZvb3Rlci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi50b3RhbHMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIGNvbG9yOiAjZjk3NTYxO1xufVxuXG4uZGF0YVRhYmxlc19pbmZvIHtcbiAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgIGZvbnQtc2l6ZTogMC45cmVtO1xufVxuXG46aG9zdCA6Om5nLWRlZXAgLnRhYmxlX2Zvb3RlciB7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgZmxleC13cmFwOiB3cmFwO1xuICAgIHBhZGRpbmc6IDA7XG4gICAgbWFyZ2luOiAwO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xufVxuXG46aG9zdCA6Om5nLWRlZXAgLnRhYmxlX2Zvb3RlciA+IGRpdiB7XG4gICAgcGFkZGluZzogNXB4O1xuICAgIG1pbi13aWR0aDogMjAwcHg7XG59XG5cbi5wYWdpbmF0aW9uIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgIGZsZXgtd3JhcDogd3JhcDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xufVxuXG4ucGFnZS1pdGVtIHtcbiAgICBtYXJnaW46IDJweDtcbn1cblxuLnBhZ2UtbGluayB7XG4gICAgcGFkZGluZzogMC4yNXJlbSAwLjVyZW07XG4gICAgZm9udC1zaXplOiAwLjg3NXJlbTtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbi5wbC0wIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDAgIWltcG9ydGFudDtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/table/table-footer/table-footer.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,yBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,uBAAA;EACA,mBAAA;EACA,eAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;AACA,wiDAAwiD","sourcesContent":[".totals {\n    display: flex;\n    justify-content: space-between;\n    color: #f97561;\n}\n\n.dataTables_info {\n    white-space: nowrap;\n    font-size: 0.9rem;\n}\n\n:host ::ng-deep .table_footer {\n    width: 100%;\n    flex-wrap: wrap;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n:host ::ng-deep .table_footer > div {\n    padding: 5px;\n    min-width: 200px;\n}\n\n.pagination {\n    margin-bottom: 0;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n}\n\n.page-item {\n    margin: 2px;\n}\n\n.page-link {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    cursor: pointer;\n}\n\n.pl-0 {\n    padding-left: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
